"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _HighlightOff = _interopRequireDefault(require("@material-ui/icons/HighlightOff"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _FiberManualRecord = _interopRequireDefault(require("@material-ui/icons/FiberManualRecord"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%',
      // maxWidth: 360,
      backgroundColor: 'transparemnt',
      padding: 0
    },
    edit: {
      display: 'grid',
      width: '100%',
      gridTemplateColumns: '1fr 6fr 1fr',
      alignItems: 'center',
      justifyContent: 'center'
    },
    confirmIcon: {
      color: '#FF9B39'
    },
    addIcon: {
      color: '#FF9B39'
    },
    removeIcon: {
      color: '#FF9B39'
    },
    itemBullet: {
      color: '#FF9B39'
    },
    itemText: {
      fontSize: '14px',
      fontWeight: 'bold'
    },
    iconContainer: {
      textAlign: 'center'
    }
  };
});

function Item(_ref) {
  var value = _ref.value,
      index = _ref.index,
      onRemove = _ref.onRemove;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.edit
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.iconContainer
  }, /*#__PURE__*/_react["default"].createElement(_FiberManualRecord["default"], {
    fontSize: 'small',
    className: classes.itemBullet
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.itemText
  }, value), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.iconContainer
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "confirm",
    onClick: function onClick() {
      return onRemove(index);
    }
  }, /*#__PURE__*/_react["default"].createElement(_HighlightOff["default"], {
    fontSize: 'large',
    className: classes.removeIcon
  })))));
}

Item.PropTypes = {
  index: _propTypes["default"].number.isRequired,
  value: _propTypes["default"].string.isRequired,
  onRemove: _propTypes["default"].func.isRequired
};

var _default = /*#__PURE__*/_react["default"].memo(Item);

exports["default"] = _default;